import React from 'react';
import AppStoreButton from '../components/AppStoreButton';
import PhoneMockup from '../components/PhoneMockup';
import { ASSETS } from '../components/assetPaths';
import './HeroSection.css';

function HeroSection() {
  return (
    <header className="hero">
      <div className="hero__nav-spacer" aria-hidden="true" />
      <div className="hero__content" id="top">
        <div className="hero__copy">
          <div className="hero__trust" aria-label="Trusted by D1 athletes. Five star rating.">
            <p>Trusted by D1 athletes.</p>
            <div className="hero__stars" aria-hidden="true">★★★★★</div>
          </div>
          <h1>Train your breath.</h1>
          <p className="hero__lead">
            Improve your endurance,<br />
            recovery, and mind.
          </p>
          <p className="hero__support">Your performance breathwork app, personalized for your fitness goals.</p>
          <AppStoreButton appleLogo text="Download for iOS" />
        </div>
        <div className="hero__device" aria-label="Ayro breathing session preview">
          <PhoneMockup type="video" src={ASSETS.breathingVideo} alt="Ayro guided breathing animation" />
        </div>
      </div>
    </header>
  );
}

export default HeroSection;
